export default __webpack_public_path__ + "static/to-top-en-955d29cb3b45765054beb45e763ab951.svg";